'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var React = require('react');
var createReactClass = require('create-react-class');
var ReactDOM = require('react-dom');
var _ = require('lodash');
var LocalizeMixin = require('../../../localization/CommonLocalizationMixin');
var IconButton = require('../../AdaIconButton.js');
var AnalyticsConstants = require('../../../lib/analytics/Constants');
var accessibilityHelper = require('../../../lib/ADAHelpers');

var FindButtons = createReactClass({
    displayName: 'FindButtons',
    mixins: [LocalizeMixin],

    render: function render() {
        return React.createElement(
            'div',
            null,
            React.createElement('input', { id: "find-directions-button-" + this.props.id, type: 'button',
                className: 'btn btn-default directions-button', value: this.getLocalizedText('find_buttons_get_directions') }),
            React.createElement('input', { id: "find-select-button-" + this.props.id, type: 'button', className: 'btn btn-default select-button',
                value: this.getLocalizedText('find_buttons_select') }),
            React.createElement('div', { className: 'clear' })
        );
    }
});

var OrderButtons = createReactClass({
    displayName: 'OrderButtons',
    mixins: [LocalizeMixin],

    render: function render() {
        var _this = this;

        var clickHandler = function clickHandler(e) {
            e.stopPropagation();
            _this.props.orderButtonClick(e);
        };

        var keyDownHandler = function keyDownHandler(e) {
            if (e.keyCode !== 27) {
                e.stopPropagation();
            }
            accessibilityHelper.keyupHandler(e);
        };

        return React.createElement(
            'div',
            null,
            React.createElement('input', { id: "find-order-button-" + this.props.id, type: 'button', className: 'btn btn-primary order-button',
                value: this.getLocalizedText('order_buttons_order_here'), onClick: clickHandler,
                onKeyDown: keyDownHandler })
        );
    }
});

var NotifyButtons = createReactClass({
    displayName: 'NotifyButtons',
    mixins: [LocalizeMixin],

    render: function render() {
        return React.createElement(
            'div',
            null,
            React.createElement('input', { id: "find-order-button-" + this.props.id, type: 'button', className: 'btn btn-default order-button',
                value: this.getLocalizedText('notify_buttons_email_me'), onClick: this.props.notifyClick, onclick: '' })
        );
    }
});

module.exports = createReactClass({
    displayName: 'exports',

    mixins: [LocalizeMixin],
    orderButtonClick: function orderButtonClick(e) {
        if (this.props.orderButtonClick) {
            e.stopPropagation();
            this.searchResultAnalytics();
            this.props.orderButtonClick(this.props.location);
        }
    },
    searchResultAnalytics: function searchResultAnalytics() {
        var self = this;
        this.props.Analytics.pushEvent(AnalyticsConstants.ORDER_HERE, this.props.Analytics.mergeParamsAndUserObj({
            Location: self.props.location.id
        }));
    },
    notifyClick: function notifyClick(e) {
        if (this.props.notifyClick) {
            e.stopPropagation();
            this.props.notifyClick(this.props.id);
        }
    },
    searchResultPinClickHandler: function searchResultPinClickHandler(e) {
        if (this.props.searchResultPinClick) {
            e.preventDefault();
            this.props.searchResultPinClick(this.props.location, true);
        }
    },
    onSelectFocus: function onSelectFocus() {
        if (ReactDOM.findDOMNode(this)) {
            var result = ReactDOM.findDOMNode(this);
            //result.offsetParent.scrollTop = result.offsetTop;
            var extra = this.props.noMobileLocations ? 283 : 0;
            $(result.parentElement).animate({ scrollTop: result.offsetTop - extra }, 300, 'swing');
        }
    },
    componentDidUpdate: function componentDidUpdate(previousProps) {
        if (previousProps.selectedResult != this.props.selectedResult && this.props.selectedResult) {
            this.onSelectFocus();
        }
    },
    clickOnSpacebarHandler: function clickOnSpacebarHandler(e) {
        if (e.keyCode === 32) {
            e.preventDefault();
            e.stopPropagation();
            e.currentTarget.click();
        }
    },
    resultKeyHandler: function resultKeyHandler(e) {
        accessibilityHelper.keyupHandler(e);
        if (e.keyCode === 27) {
            accessibilityHelper.focusOnElementAfterModalTransition('#find-distance-' + this.props.location.id, 'close');
        }
    },
    buildAmenitiesIcon: function buildAmenitiesIcon(imageName, active, text) {
        return React.createElement(
            'div',
            { className: 'inline' },
            React.createElement('img', { src: '/images/common/amenities/ic_brown_' + imageName + '_' + (active ? "normal" : "disabled") + '.png',
                role: 'icon', alt: active ? text : '' }),
            React.createElement(
                'span',
                { className: 'toolTip', 'aria-hidden': 'true' },
                text
            )
        );
    },
    render: function render() {
        var location = this.props.location;
        var hours;
        if (location.hours) {
            hours = location.hours;
        } else {
            hours = this.getLocalizedText('times_not_available');
        }
        var buttons = React.createElement(FindButtons, _extends({}, this.props, { id: this.props.id, location: this.props.location }));
        var favoriteToggle = '';

        if (this.props.buttonType == "ordering") {
            if (location.hasMobileOrder) {
                buttons = React.createElement(OrderButtons, _extends({}, this.props, { id: this.props.id, orderButtonClick: this.orderButtonClick }));
            } else {
                buttons = ''; //(this.props.cntry!='CA')?<NotifyButtons {...this.props} id={this.props.id} notifyClick={this.notifyClick}/>:'';
            }
        } else {
            favoriteToggle = React.createElement(
                'div',
                { onClick: this.toggleFavorite, className: 'favorite-button' },
                React.createElement(
                    'div',
                    { className: this.props.isFavorite ? 'glyph-button favorite' : 'favorite' },
                    React.createElement('span', { id: "find-favorite-" + this.props.id, className: 'glyphicon glyphicon-heart' })
                )
            );
        }

        var pinColor = "_brown";
        if (this.props.selectedResult) {
            pinColor = "_red";
        } else if (this.props.location.hasMobileOrder) {
            pinColor = "_blue";
        }

        var pinIcon = "/images/common/icons/ic_pin" + pinColor + ".png";

        var phone = '';
        if (location.phone && _.isString(location.phone)) {
            phone = '(' + location.phone.substring(0, 3) + ') ' + location.phone.substring(3, 6) + '-' + location.phone.substring(6, 10);
        }

        var distanceUnit = {
            mi: this.getLocalizedText('ada_miles'),
            km: this.getLocalizedText('ada_kilometers')

        };
        var distanceText = this.roundSafely(location.distance) + ' ' + (this.props.distanceUOM || '');
        var ariaLabelText = this.roundSafely(location.distance) + ' ' + distanceUnit[this.props.distanceUOM] + '\n            ' + location.title + ' ' + this.getLocalizedText('ada_find_enter_to_select');

        var ariaPinHandler = {};
        var ariaResultHandler = {};
        if (this.props.id != 'modal') {
            ariaPinHandler['aria-label'] = ariaLabelText;
            ariaPinHandler.role = 'gridcell';
            ariaPinHandler.tabIndex = '0';
            ariaPinHandler.onClick = this.searchResultPinClickHandler;
            ariaPinHandler.onKeyDown = this.resultKeyHandler;
        } else {
            ariaResultHandler.tabIndex = '0';
            ariaResultHandler.style = { overflow: 'hidden' };
        }
        return React.createElement(
            'div',
            { id: "ada-result-" + this.props.id, className: 'row search-result-container', onClick: this.searchResultPinClickHandler, onKeyDown: this.resultKeyHandler },
            React.createElement(
                'div',
                _extends({ className: 'col-xs-3 distance', id: "find-distance-" + this.props.id }, ariaPinHandler),
                React.createElement('img', { className: 'marker-icon', src: pinIcon, alt: '', role: 'icon' }),
                React.createElement(
                    'p',
                    { className: 'IntroBold' },
                    distanceText
                )
            ),
            React.createElement(
                'div',
                { className: 'col-xs-7 col-sm-8 col-md-7 info-parent-container' },
                React.createElement(
                    'div',
                    _extends({ id: "find-description-" + this.props.id, className: 'row info' }, ariaResultHandler),
                    React.createElement(
                        'div',
                        { onClick: this.onSelectFocus },
                        React.createElement(
                            'h3',
                            null,
                            location.title
                        ),
                        React.createElement(
                            'p',
                            null,
                            location.address1
                        ),
                        React.createElement(
                            'p',
                            null,
                            location.address2
                        ),
                        React.createElement(
                            'p',
                            { className: 'hours IntroBold' },
                            this.getLocalizedText('search_result_open'),
                            ': ',
                            hours
                        ),
                        React.createElement(
                            'div',
                            { id: "find-offerings-" + this.props.id, className: 'offerings' },
                            this.buildAmenitiesIcon('mobile', location.hasMobileOrder, this.getLocalizedText('amenities_mobile_order')),
                            this.buildAmenitiesIcon('mobilepay', location.hasMobilePay, this.getLocalizedText('amenities_mobile_pay')),
                            this.buildAmenitiesIcon('wifi', location.hasWifi, this.getLocalizedText('amenities_wifi')),
                            this.buildAmenitiesIcon('late', location.isOpenLate, this.getLocalizedText('amenities_open_late')),
                            this.buildAmenitiesIcon('always_open', location.isOpen24Hours, this.getLocalizedText('amenities_always_open')),
                            this.buildAmenitiesIcon('breakfast', location.hasBreakfast, this.getLocalizedText('amenities_breakfast')),
                            this.buildAmenitiesIcon('freestyle', location.hasCokeFreestyle, this.getLocalizedText('amenities_freestyle'))
                        )
                    )
                ),
                React.createElement(
                    'div',
                    { className: 'buttons' },
                    buttons
                )
            ),
            React.createElement(
                'div',
                { className: 'col-xs-2 col-sm-1 col-md-2 remove-padding' },
                React.createElement(
                    'div',
                    { className: 'fav-icon' },
                    React.createElement(IconButton, {
                        accessibilityHelper: this.clickOnSpacebarHandler,
                        attributesForADA: {
                            role: "checkbox",
                            "aria-label": this.getLocalizedText('ada_space_to_toggle') + ' ' + this.getLocalizedText('ada_favorite'),
                            "aria-checked": this.props.isFavorite ? 'true' : 'false'
                        },
                        id: 'product-fav-icon',
                        handleClick: this.favoriteLocationClick,
                        iconAlt: this.getLocalizedText('ada_favorite'),
                        image: "/images/common/icons/ic_heart_" + (this.props.isFavorite ? "selected.png" : "normal.png") })
                )
            )
        );
    },
    favoriteLocationClick: function favoriteLocationClick(e) {
        e.stopPropagation();
        this.props.favoriteLocationClick(this.props.location, this.props.isFavorite);
        return false;
    },
    roundSafely: function roundSafely(distance) {
        var ret = distance;
        try {
            if (!isNaN(distance)) {
                ret = Math.round(distance * 100) / 100;
            }
            return ret.toFixed(1);
        } catch (err) {
            console.log(err);
        }
        console.log("Distance is not a number.");
        return "N/A";
    },
    toggleFavorite: function toggleFavorite() {
        //TODO: check if user is logged in , cookie?
        if (this.props.toggleFavorite) {
            this.props.toggleFavorite(this.props.id);
        }
    }
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/components/findLocationComponents/search/SearchResult.js
// module id = 328
// module chunks = 0